<ng-container [formGroup]="group">
  <ngb-rating
    [id]="id"
    [ngClass]="getClass('element', 'control')"
    [formControlName]="model.id"
    [resettable]="model.getAdditional('resettable', config['resettable'])"
    [rate]="model.value"
    [max]="model.max"
    [disabled]="model.disabled"
    (rateChange)="onChange($event)"
    (hover)="onCustomEvent($event, 'hover')"
    (leave)="onCustomEvent($event, 'leave')"
  >
    <ng-template let-fill="fill">
      <span class="star-rating" [class.star-rating-filled]="fill === 100">
        <span class="half" [style.width.%]="fill">&#9733;</span>&#9733;
      </span>
    </ng-template>
  </ngb-rating>
</ng-container>
